/* ============================================================
   Floating-local calendar-day math, done entirely in UTC.

   Every recurrence date is a "YYYY-MM-DD" wall-clock day with no time-of-day. We
   deliberately map each to UTC midnight and do all arithmetic there: it makes
   "which calendar day" pure date math, immune to the host's local offset and to
   DST discontinuities. rrule.js is fed these same UTC anchors (see expand.ts), so
   nothing here ever consults the ambient clock — callers always pass `today`.
   ============================================================ */

/** "YYYY-MM-DD" → Date at UTC midnight of that day. */
export function ymdToUTC(ymd: string): Date {
  const [y, m, d] = ymd.split('-').map(Number) as [number, number, number];
  return new Date(Date.UTC(y, m - 1, d));
}

/** Date → "YYYY-MM-DD" using UTC fields. */
export function utcToYMD(date: Date): string {
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, '0');
  const d = String(date.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Shift a "YYYY-MM-DD" day by whole days (may be negative). */
export function addDaysYMD(ymd: string, days: number): string {
  const base = ymdToUTC(ymd);
  base.setUTCDate(base.getUTCDate() + days);
  return utcToYMD(base);
}
